import Vue from 'vue'
import Vuex from 'vuex'

/* Theme Core */
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* App Core */
import users from './Admin/Core/users'
import userTypes from './Admin/Core/user_types'
import abilities from './Admin/Core/abilities'
import cropperUploads from './Admin/Core/cropper_uploads'
import fileUpload from './Admin/Core/file_upload'
/* App Data */
import dashboard from './Admin/App/dashboard'
import downloads from './Admin/App/downloads'
import downloadLogs from './Admin/App/download_logs'
import products from './Admin/App/products'
import productFiles from './Admin/App/product_files'
import productPrices from './Admin/App/product_prices'
import productFileVersions from './Admin/App/product_file_versions'
import productMediaGallery from './Admin/App/product_media_gallery'
import projectMediaGallery from './Admin/App/project_media_gallery'
import serviceMediaGallery from './Admin/App/service_media_gallery'

import teams from './Admin/App/teams'
import teamMembers from './Admin/App/team_members'
import projects from './Admin/App/projects'
import projectFiles from './Admin/App/project_files'
import services from './Admin/App/services'
import servicePrices from './Admin/App/service_prices'
import serviceFiles from './Admin/App/service_files'
import serviceFileVersions from './Admin/App/service_file_versions'
import trashBin from './Admin/App/trashbin'
/* App Defines */
import departments from './Admin/Defines/departments'
import documentGroups from './Admin/Defines/document_groups'
import currencies from './Admin/Defines/currencies'
import units from './Admin/Defines/units'
import taxes from './Admin/Defines/taxes'
import origins from './Admin/Defines/origins'
import productCategories from './Admin/Defines/product_categories'
import serviceCategories from './Admin/Defines/service_categories'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    abilities,
    cropperUploads,
    dashboard,
    downloads,
    downloadLogs,
    fileUpload,
    users,
    userTypes,
    verticalMenu,
    productPrices,
    productFiles,
    productFileVersions,
    productMediaGallery,
    projectMediaGallery,
    serviceMediaGallery,
    products,
    departments,
    teams,
    teamMembers,
    projects,
    projectFiles,
    services,
    servicePrices,
    serviceFiles,
    serviceFileVersions,
    documentGroups,
    currencies,
    units,
    taxes,
    origins,
    productCategories,
    serviceCategories,
    trashBin,
  },
  strict: process.env.DEV,
})
